export var ReactQueryCacheKey = /* @__PURE__ */ ((ReactQueryCacheKey2) => {
  ReactQueryCacheKey2["CameraPermission"] = "CameraPermission";
  ReactQueryCacheKey2["DensityChartData"] = "DensityChartData";
  ReactQueryCacheKey2["LocalActivities"] = "localActivities";
  ReactQueryCacheKey2["OnchainBalances"] = "OnchainBalances";
  ReactQueryCacheKey2["OnchainENS"] = "OnchainENS";
  ReactQueryCacheKey2["PasskeyAuthStatus"] = "PasskeyAuthStatus";
  ReactQueryCacheKey2["PositionCurrencyInfo"] = "positionCurrencyInfo";
  ReactQueryCacheKey2["PositionTokenURI"] = "PositionTokenURI";
  ReactQueryCacheKey2["ReferralWhitelistPools"] = "ReferralWhitelistPools";
  ReactQueryCacheKey2["SignatureToActivity"] = "SignatureToActivity";
  ReactQueryCacheKey2["TradingApi"] = "TradingApi";
  ReactQueryCacheKey2["TransactionToActivity"] = "TransactionToActivity";
  ReactQueryCacheKey2["UniswapApi"] = "UniswapApi";
  ReactQueryCacheKey2["UnitagsApi"] = "UnitagsApi";
  ReactQueryCacheKey2["WalletGetCapabilities"] = "WalletGetCapabilities";
  ReactQueryCacheKey2["MismatchAccount"] = "MismatchAccount";
  ReactQueryCacheKey2["IsSmartContractAddress"] = "IsSmartContractAddress";
  ReactQueryCacheKey2["WalletDelegation"] = "WalletDelegation";
  return ReactQueryCacheKey2;
})(ReactQueryCacheKey || {});
